import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4543040b"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container-fluid d-flex flex-column align-items-center pt-5" }, [
  /*#__PURE__*/_createElementVNode("iframe", {
    src: "https://store.steampowered.com/widget/1054340/",
    width: "646",
    height: "190",
    frameborder: "0"
  }),
  /*#__PURE__*/_createElementVNode("iframe", {
    class: "mt-3",
    src: "https://itch.io/embed/393774",
    width: "552",
    height: "167",
    frameborder: "0"
  })
], -1))

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_TitleTag = _resolveComponent("TitleTag")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_TitleTag, { title: "Buy the game" }),
    _hoisted_1
  ], 64))
}